<template>
  <div class="sys-db-tools-page">
    <el-form :inline="true" label-position="left">
      <el-form-item label="SQL">
        <el-input type="textarea" v-model="sqlText" rows="5" style="width:800px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onExecute">执 行</el-button>
      </el-form-item>
    </el-form>

    <table class="el-table el-table--fit el-table--border el-table--enable-row-hover">
      <thead>
        <th class="el-table_3_column_11 is-leaf" v-for="col in columns" :key="col">{{col}}</th>
      </thead>
      <tbody>
        <tr v-for="(item,idx) in sqlDatas" :key="idx">
          <td v-for="(val, key) in item" :key="key">{{val}}</td>
        </tr>
      </tbody>
    </table>

    <el-form :inline="true" label-position="left">
      <el-form-item label="DES">
        <el-input type="textarea" v-model="desSource" rows="5" style="width:800px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onDESEncrypt">执 行</el-button>
      </el-form-item>
      <el-form-item label="Result">
        <el-input type="textarea" v-model="desResult" rows="5" style="width:800px;"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {executeSql, desEncrypt} from '../../api/system'

export default {
  data() {
    return {
      sqlText:"",
      sqlDatas:[],
      columns:[],
      desSource:"",
      desResult:"",
      loading:false
    };
  },
  created(){
  },
  methods:{
    onExecute:function(){
      this.loading = true
      executeSql(this.sqlText).then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.sqlDatas = resp.data.data;
          if (this.sqlDatas && this.sqlDatas.length > 0){
            this.columns = [];
            for(var i in this.sqlDatas[0]){
              this.columns.push(i)
            }
          }
        }else{
          this.$notify.error({title: '失败',message: "加载数据失败：" + resp.data.msg})
        }
      },err=>{
        this.loading = false
        this.$notify.error({title:'查询失败',message:err.statusText})
      });
    },
    onDESEncrypt: function(){
      this.loading = true
      desEncrypt(this.desSource).then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.desResult = resp.data.data;
        }else{
          this.$notify.error({title: '失败',message: "加密数据失败：" + resp.data.msg})
        }
      },err=>{
        this.loading = false
        this.$notify.error({title:'加密失败',message:err.statusText})
      });
    }
  }
}
</script>
